<template>
    <div class="flex gap-8 ml-0 flex-column w-full md:w-2/3 lg:w-1/3">
        <FeaturesCheckboxes ref="featuresCheckboxes" :object="scope" />
    </div>
</template>
<script>

import ApplicationService from "@/modules/Admin/Services/ApplicationService";
import loader from "@/modules/Shared/Mixins/loader";
import FeaturesCheckboxes from "@/modules/Admin/Components/FeaturesCheckboxes.vue";
import AuthorizationService from "@/modules/Admin/Services/AuthorizationService";
import PaginationService from "@/modules/Shared/Services/PaginationService";

export default {
    name: 'FeaturesSettings',
    components: {FeaturesCheckboxes},
    mixins: [loader],
    data() {
        return {
            application: null,
            scope: {
                scope_type: {
                    id: 1,
                    name: 'application'
                },
                object_id: null,
                object_uuid: null,
                enabled_features: []
            },
            isEdit: false,
        }
    },

    methods: {
        async onActive() {
            await this.loadAndNotifyError(async () => {
                this.application = await ApplicationService.getApplication(this.$route.params.uuid)

                const scopes = await AuthorizationService.getScopes(PaginationService.parseParameters({
                    filters: [
                        { field: 'scope_type', value: 'application' },
                        { field: 'name', value: this.application.name }
                    ]
                }));

                if (scopes.data.length === 1 && scopes.data[0].name === this.application.name) {
                    this.isEdit = true
                    this.scope = scopes.data[0]
                }
            })
        },
        save() {
            return new Promise(async (resolve, reject) => {
                this.loadAndNotifyError(async () => {
                    const enabledFeatures = this.$refs.featuresCheckboxes.getEnabledFeatures().map(featureId => ({ id: featureId }))

                    if (this.isEdit) {
                        return AuthorizationService.editScope(this.scope.id, {
                            enabled_features: enabledFeatures
                        })
                    } else {
                        return AuthorizationService.createScope({
                            object_id: this.application.id,
                            object_uuid: this.application.uuid,
                            scope_type_id: 1,
                            enabled_features: enabledFeatures,
                        })
                    }
                }).then((result) => {
                    if (!result) {
                        reject()
                        return;
                    }
                    resolve()
                })
            })
        }
    }
}
</script>
